module.exports = __webpack_public_path__ + "assets/img/imow_models_S1.adaaff15.jpg";